import React, { FunctionComponent, useMemo } from "react"
import ReactTable from "react-table-6"
import { mappedCollections } from "../../../api/Definitions"
import { iUser } from "../../../definitions/User"
import { post } from "../../../store/data/actions"
import s from "./Profile.less"

interface iProps {
  item: iUser
  handleCancelSubscription: () => void
}

const tableColumns = [
  {
    Header: "Available Assets",
    accessor: "collection",
  },
  {
    Header: "Total",
    accessor: "total",
  },
  {
    id: "used",
    Header: "Remaining",
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    accessor: (d: any) => d.total - d.used,
  },
]

const ProfileSubscription: FunctionComponent<iProps> = ({
  item,
  handleCancelSubscription,
}) => {
  const packageObj = useMemo(() => {
    return item?.package
  }, [item.package])

  const data = useMemo(() => {
    const data = []
    if (packageObj) {
      if (packageObj.rules) {
        for (let i = 0; i < packageObj.rules.length; i++) {
          const rule = packageObj.rules[i]
          const used =
            packageObj.usedFromPackage?.find(
              (x) => x.collection === rule.collection,
            ) || 0
          data.push({
            collection: mappedCollections[rule.collection],
            total: rule.count,
            used,
          })
        }
      }
      if (packageObj.oneTime) {
        for (let i = 0; i < packageObj.oneTime.length; i++) {
          const rule = packageObj.oneTime[i]
          const used =
            packageObj.usedFromPackage?.find(
              (x) => x.collection === rule.collection,
            ) || 0
          data.push({ collection: rule.collection, total: rule.count, used })
        }
      }
    }

    return data
  }, [packageObj])

  return packageObj ? (
    <div className={`scrollable container ${s.subscriptionRoot}`}>
      <div className={s.header}>
        <h2>{packageObj?.name}</h2>
        <button
          onClick={handleCancelSubscription}
          className={`btn-red ${s.btnCancel}`}
          type="button"
        >
          Cancel Subscription
        </button>
      </div>
      <div className={s.spaceWrap}>
        {packageObj.space && (
          <div>
            <h4>Spaces</h4>
            <div className="row">
              {packageObj?.space.map((sp, i) => (
                <div key={i} className={`${s.spaceItem}`}>
                  <span>{sp}</span>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
      <div className={s.assets}>
        <ReactTable
          filterable={false}
          sortable={false}
          showPagination={false}
          showFilters={false}
          showPageJump={false}
          data={data}
          columns={tableColumns}
          pageSize={data.length}
        />
      </div>
    </div>
  ) : (
    <div className="scrollable">
      <p>No package.</p>
    </div>
  )
}

export default ProfileSubscription
